var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Employees",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_group_24px",
    className: "cls-2",
    d: "M12.94,9.776a2.388,2.388,0,1,0-2.388-2.388A2.378,2.378,0,0,0,12.94,9.776Zm-6.368,0A2.388,2.388,0,1,0,4.184,7.388,2.378,2.378,0,0,0,6.572,9.776Zm0,1.592C4.717,11.368,1,12.3,1,14.154v1.99H12.144v-1.99C12.144,12.3,8.427,11.368,6.572,11.368Zm6.368,0c-.231,0-.494.016-.772.04a3.359,3.359,0,0,1,1.568,2.746v1.99h4.776v-1.99C18.512,12.3,14.795,11.368,12.94,11.368Z",
    transform: "translate(-1 -5)",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.a4fe98d6e2cf35af69f31231faa9db7e.svg";
export { ForwardRef as ReactComponent };